/**
 * Say it once (Due Diligence cleanup, batch 2): a list of review areas is never dumped inline. Up to FEW are named
 * verbatim; beyond that the first FEW and "and N more", and the rest is reachable (the FewNamed component opens it).
 * The API's gate details are built by the same rule (apps/backend-api .../dueDiligence/lib.ts).
 */
export const FEW = 3;
export const fewNamed = (items: readonly string[], few = FEW): string =>
  items.length <= few ? items.join(", ") : `${items.slice(0, few).join(", ")} and ${items.length - few} more`;
